import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M9.2692 30.7884H38.7307V25.1346H9.2692V30.7884ZM9.2692 22.8654H38.7307V17.1923H9.2692V22.8654ZM9.2692 14.9231H38.7307V9.2692H9.2692V14.9231ZM7 40.9999V7H40.9999V40.9999H7ZM9.2692 38.7307H38.7307V33.0576H9.2692V38.7307Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map